"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const react_1 = require("react");
const useOnClickOutside = (ref, handler, isActive = true) => {
    (0, react_1.useEffect)(() => {
        const handleClick = (e) => {
            if (ref.current &&
                handler &&
                document.body.contains(e.target) &&
                !ref.current.contains(e.target)) {
                handler();
            }
        };
        if (isActive) {
            document.addEventListener('touchstart', handleClick);
            document.addEventListener('mousedown', handleClick);
            document.addEventListener('click', handleClick);
        }
        return () => {
            document.removeEventListener('touchstart', handleClick);
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('click', handleClick);
        };
    }, [handler, isActive, ref]);
};
exports.useOnClickOutside = useOnClickOutside;
//# sourceMappingURL=index.js.map